import { NotixApi } from "Services/api";

export async function dataUrlToFile(dataUrl, fileName) {
  if (!dataUrl) {
    return null;
  }

  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], fileName, { type: "image/png" });
}

class Materials {
  async upload(images) {
    const form = new FormData();

    await form.append(
      "icon",
      await dataUrlToFile(images.icon, "material_icon")
    );
    await form.append(
      "image",
      await dataUrlToFile(images.image, "material_image")
    );

    return NotixApi.post(`/images/upload`, form).then((result) => {
      return result;
    });
  }

  async uploadImgPrerequest(images) {
    const form = new FormData();

    await form.append(
      "icon",
      await dataUrlToFile(
        images.icon,
        `material_icon__${images.icon?.substr(images.icon?.length - 4)}`
      )
    );
    await form.append(
      "image",
      await dataUrlToFile(
        images.image,
        `material_image__${images?.image?.substr(images.image.length - 4)}`
      )
    );

    return NotixApi.post(`/images/upload`, form).then((result) => {
      return result;
    });
  }
}

const materialsInstance = new Materials();

export default materialsInstance;